import { useQueryString, WithChildren } from '@carafe/components';
import { createCookie, deleteCookie } from '@carafe/cookies';
import React from 'react';

/**
 * Provider component to set the release cookie for pilot testing
 * based on the 'release' query string parameter. Removes the param from the url too.
 * This allows us to easily switch between releases for testing purposes.
 */
export const PilotProvider = ({ children }: WithChildren): JSX.Element => {
  const [release] = useQueryString(['release']);

  if (release) {
    // Any non-local development is considered production
    const domain =
      process.env.NODE_ENV === 'production'
        ? '.vintrace.app'
        : location.hostname;

    if (release === 'green') {
      document.cookie = createCookie(
        'green',
        domain,
        '/',
        'release',
        86400,
        false,
      );
    } else if (release === 'blue') {
      document.cookie = deleteCookie('green', domain, 'release', false);
    }

    deleteReleaseParameterFromUrl();
  }

  return <>{children}</>;
};

const deleteReleaseParameterFromUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('release');
  window.history.replaceState({}, '', url.toString());
};
